<template>
  <span
    class="auth-ui-tooltip-button-container"
    @click.stop="showTooltip()"
    @mouseover="showTooltip(true)"
    @mouseout="showTooltip(false)"
  >
    <slot />
    <transition
      :name="transition"
    >
      <div
        v-show="showToolTip"
        :class="{
          [customClass]: customClass.length,
          'auth-ui-tooltip-button-container-right': triangleRight,
          'auth-ui-tooltip-button-container-left': !triangleRight,
        }"
        class="auth-ui-tooltip-container"
        role="alert"
      >
        <div>
          <p class="auth-ui-tooltip-text">
            {{ tooltipText }}
          </p>
        </div>
      </div>
    </transition>
  </span>
</template>

<script>
/* ============
 * Tooltip Component
 * ============
 *
 */

export default {

  name: 'Tooltip',

  props: {
    customClass: {
      type: String,
      default: '',
      required: false,
    },
    tooltipText: {
      type: String,
      default: '',
      required: true,
    },
    transition: {
      type: String,
      default: 'fade',
      required: false,
    },
    triangleRight: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      showToolTip: false,
    };
  },

  methods: {
    showTooltip(doShow) {
      if (doShow === undefined) {
        this.showToolTip = !this.showToolTip;
      } else {
        this.showToolTip = doShow;
      }
    },
  },
};
</script>
